<template>
  <a-card :bordered='false'>
    <div class=' m-b-22 '>
      <span class="fz-20 s_font_b">昨日概况</span>
      <!-- <span class='fz-16 s_c999'>（2020-10-12 00:00:00~23:59:59）</span> -->
    </div>
    <div class="s_flex_bian_c">
      <div class="width33 s_bf4f p-l-15 p-r-15">
        <div class="s_bb1_cd0d height-44 s_flex_ali fz-18 s_font_b">
          <img class="width-17 height-20 m-r-10" src="@/assets/images/assets/hongbao-4@2x.png" alt=""> 红包
        </div>
        <div class="p-t-18 p-b-18 s_flex_ali">
          <div class="width50">
            <p class="fz-14">红包发放总额</p>
            <p class="fz-34  m-t-34 m-b-10">{{getData.bonusMoney}}<span class="fz-14">(元)</span></p>
            <!-- <p class="fz-16 s_c999">较前一日+3000</p> -->
          </div>
          <div class="width50">
            <p class="fz-13">昨日发放额</p>
            <p class="fz-34  m-t-34 m-b-10">{{getData.yesterdayBonusMoney}}<span class="fz-14">(元)</span></p>
            <!-- <p class="fz-16 s_c999">较前一日+3000</p> -->
          </div>
        </div>
      </div>
      <div class="width33 s_bf4f p-l-15 p-r-15">
        <div class="s_bb1_cd0d height-44 s_flex_ali fz-18 s_font_b">
          <img class="width-20 height-20 m-r-10" src="@/assets/images/assets/jifen-3@2x.png" width="16" alt=""> 积分
        </div>
        <div class="p-t-18 p-b-18 s_flex_ali">
          <div class="width50">
            <p class="fz-14">积分发放总数</p>
            <p class="fz-34  m-t-10 m-b-10">{{getData.point_sent}}</p>
            <p class="fz-16 s_c999 s_flex_ali"><img src="@/assets/images/customer/yestody.png" width="16" class="m-r-5" alt="">+{{getData.yesterday_point_sent}}</p>
          </div>
          <div class="width50">
            <p class="fz-14">积分消耗总数</p>
            <p class="fz-34  m-t-10 m-b-10">{{getData.point_consumption}}</p>
            <p class="fz-16 s_c999 s_flex_ali"><img src="@/assets/images/customer/yestody.png" width="16" class="m-r-5" alt="">+{{getData.yesterday_point_consumption}}</p>
          </div>
        </div>
      </div>
      <div class="width33 s_bf4f p-l-15 p-r-15">
        <div class="s_bb1_cd0d height-44 s_flex_ali fz-18 s_font_b">
          <img class="width-20 height-17 m-r-10" src="@/assets/images/assets/qiaquan@2x.png" width="16" alt=""> 优惠券
        </div>
        <div class="p-t-18 p-b-18 s_flex_ali">
          <div class="width50">
            <p class="fz-14">优惠券发放总数</p>
            <p class="fz-34  m-t-10 m-b-10">{{getData.coupon_sent}}</p>
            <p class="fz-16 s_c999 s_flex_ali"><img src="@/assets/images/customer/yestody.png" width="16" class="m-r-5" alt="">+{{getData.yesterday_coupon_sent}}</p>
          </div>
          <div class="width50">
            <p class="fz-14">优惠券消耗总数</p>
            <p class="fz-34  m-t-10 m-b-10">{{getData.coupon_consumption}}</p>
            <p class="fz-16 s_c999 s_flex_ali"><img src="@/assets/images/customer/yestody.png" width="16" class="m-r-5" alt="">+{{getData.yesterday_coupon_consumption}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="m-t-60 s_flex s_border">
      <div class="active_item" :class="{'active':active==0}" @click="changeEcharts(0)">红包</div>
      <div class="active_item" :class="{'active':active==1}" @click="changeEcharts(1)">积分</div>
      <div class="active_item" :class="{'active':active==2}" @click="changeEcharts(2)">优惠券</div>
      <div class="flex_1 s_flex_end" >
          <div class="days_item" :class="{'active':day_active==7}"  @click="getCouponAssetsIndex(7)">近7天</div>
           <div class="days_item" :class="{'active':day_active==30}" @click="getCouponAssetsIndex(30)">近30天</div>
      </div>
    </div>
    <div class="s_wid100 m-t-50" style="min-height:420px">
      <a-spin :spinning="Loading" tip="Loading...">
      <lineChart ref="myRef" v-show="!Loading"></lineChart>
      </a-spin>
    </div>
  </a-card>
</template>
<script>
  import { DownOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { getAssets,couponAssetsIndex } from "@/api/assets";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  import lineChart from './components/lineChart.vue'

  export default {
    components: { lineChart },
    setup() {
      const myRef = ref(null)
      const state = reactive({
        dataMore:{},
        active:0,
        day_active:7,
        getData:{},
        coupon_echart:{}, //优惠
        point_echart:{}, //积分
        red_echart:{}, //红包
        Loading:false
      });
      
      const changeEcharts = function(val){
           state.active = val;
          if(state.active==0){ //红包
                myRef.value.renderEcharts(state.red_echart)
          }else if(state.active==1){ //积分
                myRef.value.renderEcharts(state.point_echart)
          }else{ //优惠
                myRef.value.renderEcharts(state.coupon_echart)
          }
      }
      //获取概况
      const getCouponAssetsIndex  = async function(value){
            state.Loading = true;
            state.day_active = value;
            let res = await couponAssetsIndex({days:value}).then(res=>res.data);
            if(iscode(res)){
              // console.log(res)
              state.getData = res.data || {}
              state.coupon_echart = {
                dataName:'发放优惠券',
                data1:[],
                date:[]
              }
              //优惠
              res.data.coupon_statics_for_days.forEach((v,i)=>{
                 state.coupon_echart.data1.push(v.total)
                 state.coupon_echart.date.push(v.date)
              })

             state.point_echart = {
                dataName:'发放积分',
                data1:[],
                date:[]
              }
              //积分
              res.data.point_statics_for_days.forEach((v,i)=>{
                 state.point_echart.data1.push(v.total)
                 state.point_echart.date.push(v.date)
              })
               //红包
              state.red_echart={
                 dataName:'发放红包',
                 data1:[],
                 date:[]
              }
               res.data.bonus_statics_for_days.forEach((v)=>{
                   state.red_echart.data1.push(v.total)
                   state.red_echart.date.push(v.date)
               })

              changeEcharts(state.active)
              state.Loading = false
            }else{
              state.Loading = false
              message.error(res.msg);
            }
      }

      onMounted(() => {
        getCouponAssetsIndex(7)
       
      });
      return {
        ...toRefs(state),
        changeEcharts,
        myRef,
        getCouponAssetsIndex
      };
    }
  };
</script>
<style lang="less" scoped>
.card {
  height: 200px;
  border-radius: 8px;
  .card_title {
    font-size: 18px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #333333;
    line-height: 33px;
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    img {
      width: 25px;
      margin-right: 5px;
    }
  }
  .card_main {
    padding-bottom: 22px;
    display: flex;
    .border-right {
      border-right: 1px solid #83c8dd;
    }
    .card_items {
      display: flex;
      flex: 1;
      .card_item {
        padding-left: 20px;
        flex: 1;
        p {
          font-size: 15px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
          line-height: 30px;
          margin-bottom: 10px;
        }
        h6 {
          font-size: 15px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 400;
          color: #333333;
          line-height: 51px;
        }
        span {
          font-size: 12px;
          font-family: SourceHanSansCN-Normal, SourceHanSansCN;
          font-weight: 400;
          color: #8E8E8E;
          line-height: 24px;
        white-space:nowrap
        }
      }
    }
    
  }
}

    .active_item{
      border: 1px solid #cecece;
      border-bottom: none;
      background: #fff;
      color: #333;
      width: 140px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      margin-left: -1px;
      cursor: pointer;
    }
    .s_border{
      border-bottom: 1px solid #cecece;
    }
    
    .days_item{
        width:100px;
        height:40px;
        text-align: center;
        line-height: 40px;
        background: #fff;
        color: #333;
        border: 1px solid #cecece;
        margin-left: -1px;
        cursor: pointer;
    }
    .active{
      background: #143960;
      color:#fff;
      border:none;
       cursor: pointer;
    }
</style>